import { render } from "./YocoPage.vue?vue&type=template&id=22713304"
import script from "./YocoPage.vue?vue&type=script&lang=js"
export * from "./YocoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__